import { CommonEntrypoint } from 'entrypoint/CommonEntrypoint';
import 'presentation/style/index.scss';
import 'presentation/style/chargeDataEnquiry/chargeDataSearch.scss'
import { ChargeHeaderMaintenanceContainer } from 'presentation/view/container/ChargeHeaderMaintenance/ChargeHeaderMaintenanceContainer';

CommonEntrypoint(<ChargeHeaderMaintenanceContainer/>) 